import React from 'react'
import RWLink from './rw_link';
import "./navigation.css"


class Navigation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isToggleOn: false
        }
    }

    handleMenuToggle = () => {
        this.setState({
            isToggleOn: !this.state.isToggleOn
        })
    }

    render () {
        return (
            <nav>
                <div style={{textAlign:"center", background: "black", cursor:"pointer"}} id="menu" onClick={this.handleMenuToggle}>
                    <span class="hamburger"></span>
                </div>
                <div className="nav">
                    <RWLink to="/" title="HOME"/>
                    <RWLink to="/about/" title="ABOUT"/>
                    <RWLink to="/contact/" title="CONTACT"/>
                    <RWLink to="/blog/" title="BLOG"/>
                    <RWLink to="/links/" title="LINKS"/>
                    {/* <RWLink to="/store/" title="STORE"/> */}
                    <RWLink to="/advertise/" title="ADVERTISE"/>
                </div>

                {this.state.isToggleOn ? (
                    <div className="nav-src">
                        <RWLink to="/" title="HOME"/>
                        <RWLink to="/about/" title="ABOUT"/>
                        <RWLink to="/contact/" title="CONTACT"/>
                        <RWLink to="/blog/" title="BLOG"/>
                        <RWLink to="/links/" title="LINKS"/>
                        {/* <RWLink to="/store/" title="STORE"/> */}
                        <RWLink to="/advertise/" title="ADVERTISE"/>
                    </div>
                ) : (
                    null
                )}
            </nav>
        )
    }
}

export default Navigation